export default function ValidateMessage({children}) {
  return (
    <span className="text-[#FF424E] text-sm font-normal">{children}</span>
  )
}